import React, { useEffect, useState } from 'react';
import { Box, Button, LinearProgress, Paper, Stack, Typography } from '@mui/material';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { toast } from 'react-toastify';
import { getApi } from 'views/services/api';
import OnboardingWizard, { STEPS } from './OnboardingWizard';

const POSTPONED_KEY = 'onboardingPostponed';

// Decide si el hotel logueado necesita el wizard de configuración inicial.
// Solo aplica a cuentas de hotel (no admin de plataforma ni empleados) cuyo
// documento tiene needsOnboarding: true (hoteles registrados tras el deploy
// del wizard; los hoteles existentes nunca lo ven).
export default function OnboardingGate() {
  const [hotel, setHotel] = useState(null);
  const [wizardOpen, setWizardOpen] = useState(false);
  const [bannerStep, setBannerStep] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  let stored = null;
  try {
    stored = JSON.parse(localStorage.getItem('hotelData'));
  } catch (e) {
    stored = null;
  }
  const isHotelAdmin = stored && String(stored.role || '').toLowerCase() === 'hoteladmin';

  useEffect(() => {
    if (!isHotelAdmin || !stored?.hotelId) return;

    const check = async () => {
      try {
        const res = await getApi(`api/hotel/view/${stored.hotelId}`);
        if (res?.status === 200 && res.data?.needsOnboarding === true) {
          setHotel(res.data);
          setBannerStep(res.data.onboardingStep || 0);
          if (sessionStorage.getItem(POSTPONED_KEY) === '1') {
            setDismissed(true);
          } else {
            setWizardOpen(true);
          }
        }
      } catch (e) {
        console.error('Error verificando onboarding:', e);
      }
    };
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!hotel) return null;

  const handlePostpone = (currentStep) => {
    sessionStorage.setItem(POSTPONED_KEY, '1');
    setBannerStep(currentStep);
    setWizardOpen(false);
    setDismissed(true);
  };

  const handleResume = () => {
    setDismissed(false);
    setWizardOpen(true);
  };

  const handleFinished = () => {
    sessionStorage.removeItem(POSTPONED_KEY);
    setWizardOpen(false);
    setHotel(null);
    toast.success('¡Tu hotel quedó configurado! Ya puedes recibir reservas.');
  };

  const progress = Math.round((bannerStep / (STEPS.length - 1)) * 100);

  return (
    <>
      <OnboardingWizard
        open={wizardOpen}
        hotel={{ ...hotel, onboardingStep: bannerStep }}
        onPostpone={handlePostpone}
        onFinished={handleFinished}
      />

      {/* Banner flotante para retomar la configuración */}
      {dismissed && !wizardOpen && (
        <Paper
          elevation={6}
          sx={{
            position: 'fixed',
            bottom: 24,
            right: 24,
            zIndex: 1200,
            p: 2,
            borderRadius: 3,
            width: 300
          }}
        >
          <Stack spacing={1.5}>
            <Stack direction="row" spacing={1} alignItems="center">
              <RocketLaunchIcon color="primary" fontSize="small" />
              <Typography variant="subtitle2" fontWeight={700}>
                Configuración del hotel: {progress}%
              </Typography>
            </Stack>
            <LinearProgress variant="determinate" value={progress} sx={{ borderRadius: 1 }} />
            <Box>
              <Button size="small" variant="contained" onClick={handleResume} sx={{ textTransform: 'none', fontWeight: 600 }}>
                Continuar configuración
              </Button>
            </Box>
          </Stack>
        </Paper>
      )}
    </>
  );
}
